module.exports = __webpack_public_path__ + "img/phone.57d4ffb6.png";